import Helper from "../../../utils/helper";

export const initialState = {
  CompleteAndConfirmReturnRequest: {
    orderId: 0,
    returnId: 0,
    customerId: 0,
    storeCode: "",
    returnedProductItemProcesses: null,
  },
};

export function buildURLFromObject(obj: any) {
  //urlden aldığı parametrelerle arama yapıyor
  const queryParams = Object.entries(obj)
    .map(([key, value]) => {
      if (
        value !== null &&
        value !== undefined &&
        ((Array.isArray(value) && value.length > 0) ||
          (!Array.isArray(value) && value !== 0 && value !== ""))
      ) {
        if (key === "Barcodes" && Array.isArray(value) && value.length > 0) {
          const encodedValues = value
            .map((v) => encodeURIComponent(String(v)))
            .join(",");
          return `${key}=${encodedValues}`;
        } else {
          return `${key}=${encodeURIComponent(String(value))}`;
        }
      }
      return "";
    })
    .filter((param) => param !== "")
    .join("&");

  return `/returnList?${queryParams}`;
}

export const getParamsReturnDetailByReturnID = (
  returnId: any,
  customerId: any
) => {
  let params: any = {};
  params.ReturnId = returnId;
  params.CustomerId = customerId;
  params.StoreCode = Helper.getStoreCode();
  return params;
};

export const isProductBarcodeMatch = (
  product: any,
  barcode: number | string
): boolean => {
  const code = Number(barcode);
  return (
    product.barcode === code || product.barcodeList?.includes(code) === true
  );
};

export const findProductsByScannedBarcode = (
  returnDatasProducts: any[],
  returnedProductItemProcesses: any[],
  scannedBarcode: string
): any[] | undefined => {
  const selectedProductsArray: any[] = [];
  const scannedBarcodeNum = Number(scannedBarcode.trim());

  for (const product of returnDatasProducts) {
    const process = returnedProductItemProcesses.find(
      (processItem: any) => processItem.returnItemId === product.returnItemId
    );

    const isMatch = isProductBarcodeMatch(product, scannedBarcodeNum);

    if (!process && isMatch) {
      selectedProductsArray.push(product);
      break;
    }

    if (
      process &&
      process.quantity >= process.restockQuantity + process.nonRestockQuantity + process.rejectedQuantity &&
      isMatch
    ) {
      selectedProductsArray.push(product);
      break;
    }
  }

  if (selectedProductsArray.length === 0) {
    return undefined;
  }

  return selectedProductsArray;
};
